import React from 'react';
import { Grid, Breadcrumb, Header, Table } from 'semantic-ui-react';
// import JuanMap from '../../app/common/Maps/JuanMap';

const sections = [
    { key: 'West Ryde', content: 'West Ryde', link: true },
    { key: 'Korean Language School', content: 'Korean Language School', active: true },
]

// const headerSize = 'large';

const SchoolPage = () => {
    return (
        <Grid>
            <Grid.Column width={16}>
                <Breadcrumb icon='right angle' sections={sections} style={{ margin: '20px' }} />
                {/* <Header content='Korean Language School' size={headerSize} /> */}
                <Table celled> 
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>Title</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      <Table.Row>
                          <Table.Cell>
                          <a href="/assets/reference/01_Statement of Commitment to Child Safety (Sydney Juan Church Language School Inc.).pdf" 
                            target="_blank" >
                            01_Statement of Commitment to Child Safety (Sydney Juan Church Language School Inc.)</a>
                          </Table.Cell>                          
                      </Table.Row>
                      <Table.Row>
                          <Table.Cell>
                          <a href="/assets/reference/03_Child Safe Code of Conduct (Sydney Juan Church Language School Inc.).pdf" 
                            target="_blank" rel="noopener noreferrer">
                          03_Child Safe Code of Conduct (Sydney Juan Church Language School Inc.)</a>
                          </Table.Cell>                          
                      </Table.Row>
                      <Table.Row>
                          <Table.Cell>
                          <a href="/assets/reference/04_Child Safe Reporting Policy (Sydney Juan Church Language School Inc.).pdf" 
                            target="_blank" rel="noopener noreferrer">
                          04_Child Safe Reporting Policy (Sydney Juan Church Language School Inc.)</a>
                          </Table.Cell>                          
                      </Table.Row>
                      <Table.Row>
                          <Table.Cell>
                          <a href="/assets/reference/06_Child Safe Risk Management Plan (Sydney Juan Church Language School Inc.).pdf" 
                            target="_blank" rel="noopener noreferrer">
                          06_Child Safe Risk Management Plan (Sydney Juan Church Language School Inc.)</a>
                          </Table.Cell>                          
                      </Table.Row>                    
                    </Table.Body>
                </Table>
            </Grid.Column>
        </Grid>
    );
};

export default SchoolPage;